export default function() {
  return new Worker(__webpack_public_path__ + "static/js/cloudSyncWorker.ec7ddd4a.worker.js");
}
